import { createTheme } from "@mui/material/styles";

// Tema profissional: paleta índigo/teal, cantos arredondados, sombras suaves,
// botões sem caixa-alta. Aplicado globalmente via ThemeProvider.
const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#3b5bdb", dark: "#2f49af", light: "#5c7cfa", contrastText: "#fff" },
    secondary: { main: "#0ca678", dark: "#099268", light: "#38d9a9", contrastText: "#fff" },
    success: { main: "#2f9e44" },
    warning: { main: "#f08c00" },
    error: { main: "#e03131" },
    background: { default: "#f4f6fb", paper: "#ffffff" },
    text: { primary: "#1f2937", secondary: "#6b7280" },
    divider: "rgba(17,24,39,0.08)",
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: -0.5 },
    h5: { fontWeight: 700, letterSpacing: -0.3 },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
        elevation1: { boxShadow: "0 1px 3px rgba(17,24,39,0.06), 0 1px 2px rgba(17,24,39,0.04)" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 10, paddingInline: 16 } },
    },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundImage: "none", boxShadow: "0 1px 2px rgba(17,24,39,0.08)" },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: { "& .MuiTableCell-head": { fontWeight: 700, color: "#374151", backgroundColor: "#f8fafc" } },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10, marginInline: 8, marginBlock: 2,
          "&.Mui-selected": { backgroundColor: "rgba(59,91,219,0.12)", "&:hover": { backgroundColor: "rgba(59,91,219,0.18)" } },
        },
      },
    },
  },
});

export default theme;
